import {ScrollArea} from '@mantine/core';
import type {GetNativeAdPostsResponse} from '../../../../../core/repositories/companyDetailRepository';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {useWindowSize} from '../../../../../shared/services/useWindowSize';
import {ColumnCard} from '../../ColumnCard';
import {SectionTitle} from './SectionTitle';

type Props = {
  companyName?: string;
  nativeAds: GetNativeAdPostsResponse;
};

export const NativeAds: React.FC<Props> = ({companyName, nativeAds}) => {
  const {isPC} = useMediaQuery();
  const {width} = useWindowSize();

  if (!('posts' in nativeAds) || nativeAds.posts.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 pc:mt-16">
      <SectionTitle id="native-ads" sectionTitle={`${companyName}の特集記事`} />
      <div
        className="mt-8 pc:mt-16"
        style={{width: isPC ? undefined : width - 32}}
      >
        <ScrollArea offsetScrollbars>
          <div className="flex gap-16">
            {nativeAds.posts.map((column) => (
              <ColumnCard key={column.id} post={column} isSponsored={true} />
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};
